
export default {
    
    approverName: state => () => state.approvers.filter((a) => a.priority === 1)[0],

    employeeFiledClaims: state => (employeeFiledClaimsId) =>  {
        return state.employeeFiledClaims.find(u => u.employeeFiledClaimsId === employeeFiledClaimsId)
    }
    

}